var RequestStatus;
(function (RequestStatus) {
    RequestStatus["Pending"] = "PENDING";
    RequestStatus["Done"] = "DONE";
    RequestStatus["Error"] = "ERROR";
})(RequestStatus || (RequestStatus = {}));

export { RequestStatus };
